import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { type LoginFormData, loginSchema } from '../../schemas/login-schema'

export function useLoginForm() {
	return useForm<LoginFormData>({
		defaultValues: {
			registration: '',
			password: '',
		},
		resolver: zodResolver(loginSchema),
		shouldFocusError: true,
		mode: 'onSubmit',
	})
}
